<template>
  <a-modal
    class="coverBox"
    v-model="visible"
    :title="title"
    @ok="ok"
    @cancel="cancel"
    destroyOnClose
    :maskClosable="false"
  >
    <a-form :form="form" class="headForm" :label-col="labelCol">
      <a-form-item label="原料代码" v-if="rawsList.length == 1"><span style="font-size: 12px;">{{details.code}}</span></a-form-item>
      <a-form-item label="选中原料" v-else>
        <div style="line-height: 17px;padding-top: 13px;font-size: 12px;">
          <span style="font-size: 12px;" v-for="ind of len" :key="ind">{{rawsList[ind - 1].name}}
            <span v-if="ind != len" style="font-size: 12px;">, </span>
          </span>
          <a v-if="rawsList.length > 5" @click="openNameList" style="font-size: 12px;">{{isOpen ? '收起' : '查看全部'}}</a>
        </div>
      </a-form-item>
      <a-form-item label="目标工厂">
        <a-select
          placeholder="请选择工厂"
          style="width: 100%"
          v-decorator="['name',{ rules: [{ required: true, message: '请选择工厂' }] }]"
        >
          <a-select-option v-for="d in searchList" :key="d.factoryId">
            {{ d.name }}({{ d.code }})
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="复制数据">
        <a-checkbox-group v-decorator="['dataArr',{ rules: [{ required: true, message: '请选择需要复制的数据' }] }]">
          <a-checkbox value="isRawPrice" name="type">原料价格</a-checkbox>
          <a-checkbox value="isFixRatio" name="type">取整系数</a-checkbox>
          <a-checkbox value="isMinWeightVal" name="type">最小称量量</a-checkbox>
          <a-checkbox value="isNutrition" name="type">营养指标</a-checkbox>
        </a-checkbox-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
export default {
  data(){
    return{
      visible: false,
      details: {},
      form: this.$form.createForm(this),
      searchList: [],
      copyRawIds: [],
      rawsList: [],
      isOpen: false,
      labelCol: { style: { width: '100px' } },
    }
  },
  computed: {
    len(){
      let num = 0
      if(this.isOpen){
        num = this.rawsList.length
      }else{
        if(this.rawsList.length > 5){
          num = 5
        }else{
          num = this.rawsList.length
        }
      }
      return num
    },
    title(){
      let title = ''
      let str = ''
      if(this.rawsList.length > 1) {
        title = '批量复制'
        str = '将选中原料批量复制到其他工厂'
      }else{
        title = this.details.name
        str = '将原料复制到其他工厂'
      }
      let s = <div style="width: 455px;">{title}<span style="color: #929292;font-size: 12px;margin-left: 2px;">{str}</span></div>
      return s
    }
  },
  methods:{
    init(data){
      this.visible = true
      let copyRawIds = []
      this.rawsList = data
      this.details = data && data.length > 0 ? data[0] : {}
      data && data.forEach(el => {
        copyRawIds.push(el.rawId)
      })
      this.copyRawIds = copyRawIds
      this.getSearchList()
    },
    cancel(){
      this.isOpen = false
    },
    ok(){
      this.form.validateFields((err,values) => {
        if(!err){
          let {name:targetFactoryId,dataArr} = values || {}
          let copyFactoryId = window.localStorage.getItem('factoryId')
          if(copyFactoryId === targetFactoryId) {
            this.$message.warning('当前工厂和目标工厂不能相同')
            return
          }
          let data = {
            copyFactoryId,targetFactoryId,
            copyStaffId: window.localStorage.getItem('staffId'),
            isRawPrice: dataArr.includes('isRawPrice') ? 1 : 0, // 原料价格
            isFixRatio: dataArr.includes('isFixRatio') ? 1 : 0,  // 取整系数
            isMinWeightVal: dataArr.includes('isMinWeightVal') ? 1 : 0, // 最小称量量
            isNutrition: dataArr.includes('isNutrition') ? 1 : 0, // 营养指标
            targetStaffId: window.localStorage.getItem('staffId'),
            copyRawIds: this.copyRawIds.join(','),
          }
          // console.log('data',data)
          this.$http.post('/nhf-app/factorystaffraw/factoryStaffRawCopyToRaw',data).then(res => {
            let {success} = res || {}
            if(success){
              this.$message.success('操作成功')
              this.visible = false
              this.isOpen = false
            }
          })
        }
      })
    },
    getSearchList() {
      let factoryId = window.localStorage.getItem("factoryId")
      this.$get("/nhf-app/formulaManage/myFactory", {
        current: 1,
        size: 1000,
        // 
      }).then((res) => {
          let { success, data } = res;
          if (success) {
            let { records=[] } = data || {};
            let list = records.filter(el => el.factoryId != factoryId)
            this.searchList = list || [];
          } else {
            this.searchList = [];
          }
        })
        .catch(() => {
          this.searchList = [];
        });
    },
    onSelect(val) {
      console.log(val,'---------')
    },
    openNameList(){
      this.isOpen = !this.isOpen
    }
  }
}
</script>
<style lang="scss">
.coverBox{
  .ant-modal-body{
    padding: 0
  }
}
</style>